<template>
  <div>
    <div v-if="workTime.add !== undefined">
      <div class="font-weight-bold">Adresas:</div>
      <div>{{ workTime.add }}</div>
    </div>
    <template v-if="showWorkTime">
      <div v-if="workTime.dd || workTime.ss" class="font-weight-bold mt-4">Darbo laikas:</div>
      <div v-if="workTime.dd !== undefined">
        <div>I-V <span>{{ workTime.dd === 0 ? 'Nedirbame' : workTime.dd }}</span><span v-if="workTime.pietus != 0">, pietų pertrauka {{ workTime.pietus }} val.</span></div>
      </div>
      <div v-if="workTime.ss !== undefined">
        <div>VI-VII <span>{{ workTime.ss === 0 ? 'Nedirbame' : workTime.ss }}</span><span v-if="workTime.pietus != 0">, pietų pertrauka {{ workTime.pietus }} val.</span></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    workTime: {
      type: Object,
      required: false,
    },
    showWorkTime: {
      type: Boolean,
      default: true,
    }
  },
}
</script>

<style scoped>
div {
  font-size: .875rem;
}
</style>
